<template>
  <div class="form-group message">
    <label>Message</label>
    <small class="form-text form-helper">Add a personal message to the recipient</small>
    <div class="form-control" :class="{ success: message }">
      <h5 class="mb-4 mt-2 text-body">Hi {{ name }},</h5>
      <textarea
        v-model="message"
        @input="$emit('input', message)"
        class="p-0 bg-transparent outline-none border-0 w-100 text-success"
        placeholder="Add a custom message here"
      />
      <p class="text-body">You have a new document to review on Clausify. Please click the link below to access the document.</p>
      <p class="text-body">
        {{ $page.props.auth.user.first_name }} {{ $page.props.auth.user.last_name }}<br />
        {{ $page.props.auth.user.organisation.name }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      message: this.value,
    };
  },
};
</script>
